module.exports = __webpack_public_path__ + "b8fc-bg-merge-box.png";